import axios from '@/axios';
import * as types from '../mutation-types'

export default {
    namespaced: true,

    state: {
        trainings: [],
        trainingEvaluationTypes: [],
    },

    actions: {
        fetchAll({ commit }) {
            return axios.get('/trainings').then(({ data }) => {
                commit(types.STORE_TRAININGS, data);
                return data;
            })
        },
        
        fetchById({ commit }, { id }) {
            return axios.get(`/trainings/${id}`).then(({ data }) => {
                return data;
            })
        },

        fetchTrainingEvaluationTypes({ commit }) {
            return axios.get('/trainings/evaluationTypes').then(({ data }) => {
                commit(types.STORE_TRAINING_EVALUATION_TYPES, data);
                return data;
            })
        },

        create({ commit }, { name, startDate, endDate, coachId, place, duration, organizers, trainees, trainingNeed, plans, evaluation, coachName }) {
            return axios.post('/trainings', { name, startDate, endDate, coachId, place, duration, organizers, trainees, trainingNeed, plans, evaluation, coachName });
        },

        update({ commit }, { id, name, startDate, endDate, coachId, place, duration, organizers, trainees, trainingNeed, plans, evaluation }) {
            return axios.put(`/trainings/${id}`, { name, startDate, endDate, coachId, place, duration, organizers, trainees, trainingNeed, plans, evaluation });
        },

        delete({ commit }, { id }) {
            return axios.delete(`/trainings/${id}`);
        },
    },

    mutations: {
        [types.STORE_TRAININGS](state, trainings) {
            state.trainings = trainings;
        },
        [types.STORE_TRAINING_EVALUATION_TYPES](state, trainingEvaluationTypes) {
            state.trainingEvaluationTypes = trainingEvaluationTypes;
        },
    }
}